import React from 'react';
import Link from '../../../Buttons/Link/Link';
import { withTranslation } from 'react-i18next';
import logo from '../../../../images/logo.svg';
import './Footer.scss';

class Footer extends React.Component {
  render() {
    const { t } = this.props;

    return (
      <footer id="footer">
        <React.Fragment>
          <Link
            className="c3d-privacy-policy"
            href="https://www.concept3d.com/concept3d-privacy-policy"
            newTab
          >
            {t('publicTour.privacyPolicy')}
          </Link>
          <Link
            className="c3d-tos"
            href="https://www.concept3d.com/concept3d-tour-builder-terms-of-service"
            newTab
          >
            {t('publicTour.terms')}
          </Link>
          <Link
            aria-label="Concept3D logo, clicking on this link will take you to concept3d.com"
            className="concept3d"
            href="https://concept3d.com/?utm_source=customer&utm_medium=referral&utm_term=360-tour"
            newTab
          >
            <img src={logo} alt="" width="100" />
          </Link>
        </React.Fragment>
      </footer>
    );
  }
}

export default withTranslation()(Footer);
